















































import { Component, Vue } from 'vue-property-decorator';
import {store} from '../_store';
import {SNACK_ACTION} from '../_store/snackbar';
import {ACCOUNT_ACTION} from "@/_store/account";
import router from "@/router";
const jsonwebtoken = require('jsonwebtoken');

@Component
export default class ResetPW extends Vue {
    private userToken: string = '';
    private success: boolean = false;
    private validEmail: boolean = false;
    private email: string = '';
    private password: string = '';
    private confPassword: string = '';
    private passwordRules = [
        (v: string) => !!v || 'Password is required',
    ];
    private confPasswordRules = [
        (v: string) => !!v || 'Confirm Password is required',
    ];

    private ValidateMatchingPass() {
        if (this.password === this.confPassword) {
            return true;
        } else {
            return false;
        }
    }

    private async submit() {
        if (!this.ValidateMatchingPass() ) {
            store.dispatch(SNACK_ACTION.ERROR, "Passwords do not match. Please try again.");
        } else {
            // passwords match, send to server. (clear error popup if there is one)
            store.dispatch(SNACK_ACTION.CLEAR);

            const success: boolean = await store.dispatch(ACCOUNT_ACTION.RESETPW,
            {token: this.userToken, password: this.password, confirmPassword: this.confPassword});

            if (success) {
                router.push("/public/login");
                store.dispatch(SNACK_ACTION.SUCCESS, 'Password updated successfully');
            }
        }
    }

    private decode(value: string): any {
        let decoded: any;
        try {
            decoded = jsonwebtoken.decode(value);
            return decoded.data;
        } catch (err) {
            return null;
        }
    }


    get env() {
        return this.$store.getters["api/env"];
    }

    private async mounted() {
        const URLParams = new  URLSearchParams(window.location.search);
        const token = URLParams.get("token");

        if (token) {
            this.userToken = token;

            // ask server if this token is valid
            const success = await store.dispatch(ACCOUNT_ACTION.VERIFYRESETTOKEN, {token: this.userToken});

            if (success) {
                // grab the email from the token
                this.email = this.decode(token);

                if (this.email) {
                    // trigger the ui to show the email, now that it is set.
                    this.validEmail = true;
                }
            } else {
                // server says invalid token. This error was already displayed by the user.services call to handleResponse()
                router.push("/public/forgot");
                store.dispatch(SNACK_ACTION.ERROR, 'Invalid Reset Token. Please request a new Password Reset Link.');

            }

        } else {
            // user landed on page with either no reset token or an invalid one.
            router.push("/public/login");
            store.dispatch(SNACK_ACTION.ERROR, 'Password Reset Token is missing. Please try the link in your email again.');
        }
    }
}
